module.exports = __webpack_public_path__ + "img/promotion4.99b52114.png";